<template>
  <div>
    <div class="row">
      <div class="col-10 col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-users" /> Pessoas
        </h2>
        <small class="text-muted"
          >Controle seus clientes, fornecedores e vendedores.</small
        >
      </div>
      <div class="col-2 col-md-6 text-right">
        <br />
        <button
          v-if="personCreateEdit"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="storePerson()"
        >
          <i class="fas fa-plus" />
          <span class="d-none d-md-inline"> Adicionar Pessoa</span>
        </button>
        <b-dropdown id="dropdown-1" text="Mais" class="m-md-2" right>
          <b-dropdown-item @click="openPersonReport()">
            <i class="fas fa-print mr-2"/>Imprimir Relatório
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item @click="exportPerson()"
            ><i class="fas fa-file-excel mr-2"/>Exportar Para Excel
          </b-dropdown-item>
        
        </b-dropdown>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-md-12">
        <ul class="nav nav-pills">
          <li class="nav-item">
            <a
              :class="['nav-link', { active: searchForm.type == 'c' }]"
              @click="changeType('c')"
              href="#"
            >
              <i class="fas fa-user-friends" /> Clientes
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', { active: searchForm.type == 'v' }]"
              @click="changeType('v')"
              href="#"
            >
              <i class="fas fa-industry" /> Fornecedores
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="['nav-link', { active: searchForm.type == 's' }]"
              @click="changeType('s')"
              href="#"
            >
              <i class="fas fa-user-tie" /> Vendedores
            </a>
          </li>
        </ul>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-12 col-md-4">
        <text-input
          @keyup.enter.native="select"
          :alias="'Pesquisar'"
          v-model="searchForm.text"
        ></text-input>
      </div>
      <div class="col-2 col-md-4 d-flex align-items-end">
        <div class="form-group">
          <button type="button" class="btn btn-sm btn-primary" @click="select">
            <i class="fas fa-search" />
            <span class="d-none d-md-inline"> Pesquisar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-form-checkbox
          switch
          inline
          :value="1"
          :unchecked-value="0"
          v-model="searchForm.status"
        >
          <small>Listar Somente Ativos</small>
        </b-form-checkbox>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-md-12">
        <table-paginator :data="people" @pagechange="select($event)">
          <template v-for="person in people.data">
            <div
              class="row grid-table-row py-3 d-flex align-items-center"
              :key="person.id"
              @click="storePerson(person.id)"
              style="cursor:pointer"
            >
              <div class="col-md-11">
                <person-label :person="person" :expanded="true" />
              </div>
              <div class="col-md-1 text-right">
                <a
                  class="btn btn-link text-success"
                  @click.stop
                  v-if="person.phone_wa != null"
                  :href="getWhatsAppLink(person)"
                  target="_blank"
                  ><i class="fab fa-lg fa-whatsapp"></i
                ></a>
              </div>
            </div>
          </template>
        </table-paginator>
      </div>
    </div>

    <error-handler :error="error" />

    <person-form ref="personForm" @stored="select" />
  </div>
</template>

<script>
  import personLabel from "@/components/person/sections/PersonLabel";
  import PersonForm from "./../components/forms/PersonForm.vue";
  import TablePaginator from "./../components/sections/TablePaginator.vue";

  export default {
    // todo feature currentPage

    components: {
      personLabel,
      PersonForm,
      TablePaginator
    },

    data: function() {
      return {
        people: {
          data: null
        },

        searchForm: {
          text: null,
          type: "c",
          status: 1
        },

        error: null
      };
    },

    created() {
      this.$store
        .dispatch("person/getPersons", {
          name: this.searchForm.text,
          type: this.searchForm.type,
          status: 1
        })
        .then(response => {
          this.people = this.persons;
        })
        .catch(error => {
          this.error = error;

          this.$store.commit("pageHasLoadedWithError", { error: error });
        });
      this.$store.commit("pageHasLoaded");
    },

    computed: {
      persons() {
        return this.$store.state.person.persons;
      },
      personCreateEdit() {
        return this.$acl.can("personCreateEdit");
      },
      exportPersons() {
        return this.$store.state.person.export_persons;
      }
    },

    methods: {
      storePerson(id = null) {
        if (this.personCreateEdit) {
          this.$refs.personForm.open(id);
        }
      },

      getInitial(value) {
        return value.slice(0, 1);
      },

      select(page = 1) {
        this.$store.commit("showLoading");

        this.$store
          .dispatch("person/getPersons", {
            page: page,
            name: this.searchForm.text,
            type: this.searchForm.type,
            status: this.searchForm.status
          })
          .then(response => {
            this.people = this.persons;

            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.error = error;
            this.$store.commit("hideLoading");

            this.error = error;
          });
      },

      changeType(type) {
        this.searchForm.type = type;
        this.select();
      },

      exportPerson() {
        this.$store.commit("showLoading");
        this.$store
          .dispatch("person/exportPersons")
          .then(response => {
            const url = window.URL.createObjectURL(
              new Blob([this.exportPersons.data])
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Pessoas.xlsx");
            document.body.appendChild(link);
            link.click();
            this.$store.commit("hideLoading");
          })
          .catch(error => {
            this.error = error;
            this.$store.commit("hideLoading");
          });
      },

      getWhatsAppLink(people) {
        let name = people.name.replace(/ .*/, "");
        let link = "https://api.whatsapp.com/send?phone=+55" + people.phone_wa;
        let msg = "&text=Olá " + name + ",Tudo Bem?";

        return link + msg;
      },
      openPersonReport() {
        window.open("/pessoas/relatorio");
      },
    }
  };
</script>

